import { render, staticRenderFns } from "./rowDetail.vue?vue&type=template&id=dbda5a14&scoped=true"
import script from "./rowDetail.vue?vue&type=script&lang=js"
export * from "./rowDetail.vue?vue&type=script&lang=js"
import style0 from "./rowDetail.vue?vue&type=style&index=0&id=dbda5a14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbda5a14",
  null
  
)

export default component.exports